import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  children: React.ReactNode;
  tag?: "h1" | "h2" | "h3" | "strong" | "p" | "span";
  kind?: "base" | "xs" | "s" | "m" | "l" | "minor" | "sub" | "hero";
  thin?: boolean;
  noWrap?: boolean;
  variant?: "inherit" | "primary" | "standout";
}

const Headline = ({
  classNames = [],
  children,
  variant = "inherit",
  noWrap = false,
  tag = "h1",
  kind = "base",
  thin = false
}: Props) =>
  React.createElement(
    tag,
    {
      className: cn(
        "Headline",
        [
          {
            [`kind-${kind}`]: kind,
            [`variant-${variant}`]: variant,
            thin,
            noWrap
          }
        ],
        classNames
      )
    },
    <>
      {/* Wrapper needed to isolate container-type from parent flex contexts */}
      <span className="Headline__children">{children}</span>
      <div className="Headline__decoration" />
    </>
  );

export default Headline;
